import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa50bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col s12 ScoreBar" }
const _hoisted_2 = { class: "col xl3 offset-xl6 l4 offset-l5 m5 offset-m2 s6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Zdobyte punkty: ")
const _hoisted_4 = { class: "col xl3 l3 m5 s6" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Średni czas: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_ctx.earnedPoints) + "/" + _toDisplayString(_ctx.maxPoint), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", null, _toDisplayString(_ctx.averageTime), 1)
    ])
  ]))
}